@if(isMobile()){
<div (click)="downloadApp()" class="download-btn">
  @switch (currentLang()) { @case (Language.English) { @if (isAndroid()) {
  <img src="./assets/download/android_en.svg" alt="Download" class="download-icon" />
  } @if (isIOS()) {
  <img src="./assets/download/apple_en.svg" alt="Download" class="download-icon" />
  } } @default { @if (isAndroid()) {
  <img src="./assets/download/android_no.svg" alt="Download" class="download-icon" />
  } @if (isIOS()) {
  <img src="./assets/download/apple_no.svg" alt="Download" class="download-icon" />
  } } }
</div>
}
